import JournalService from '../../services/journal.service.js';
import ProfileService from '../../services/profile.service.js';
import SecurityService from '../../services/security.service';
import { loadLanguageAsync } from '../../i18n.js';
import { ASSIGNABLE_ROLES, STUDENT_ROLE, ALL_ROLES } from '../../assets/constants.js';
import i18n from '../../i18n';

export const state = {
  profileData: null,
  profileForms: []
};

export const getters = {
  getRoles(state, excludeStudent = true) {
    const userRole = state.profileData.role;
    const roleList = ASSIGNABLE_ROLES[userRole].includes(userRole)
      ? ASSIGNABLE_ROLES[userRole]
      : ALL_ROLES;
    const newRoleList = roleList
      .filter((role) => !excludeStudent || role !== STUDENT_ROLE)
      .map((role) => {
        role = { key: role, value: i18n.t(`nouns.roles.${role}`) };
        return role;
      });
    return newRoleList;
  },
  lang(state) {
    return state.profileData ? state.profileData.lang : 'en';
  },
  isScormClientAdmin(state) {
    return !!state.profileData?.isScormClientAdmin;
  },
  getWeekNotifications() {
    let weekList = [];
    if (i18n.availableLocales.length) {
      weekList = [
        { key: 1, value: i18n.t('account.forms.weeks.1') },
        { key: 2, value: i18n.t('account.forms.weeks.2') },
        { key: 4, value: i18n.t('account.forms.weeks.4') }
      ];
    }
    return weekList;
  }
};

export const actions = {
  async getProfile({ commit }) {
    try {
      const { data: profileData } = await ProfileService.getProfile();
      commit('SET_PROFILE', profileData);
      commit('SET_PROFILE_FORMS', profileData);
      JournalService.dispatchStartSession();
      return profileData;
    } catch (err) {
      console.error(err);
    }
  },
  async updateProfileData({ commit, state, dispatch }, data) {
    const { body, notification } = data;
    try {
      const updatedUserData = await ProfileService.updateProfile(state.profileData.id, body);
      commit('SET_PROFILE', { ...state.profileData, updatedUserData });
      dispatch('addNotification', notification);
      dispatch('getProfile');
      return updatedUserData;
    } catch (err) {
      const errorNotification = {
        type: 'error',
        message: `feedback.errors.${notification.fieldToEdit}`,
        show: notification.show
      };

      dispatch('addNotification', errorNotification);
      console.error(err);
    }
  },
  async changePassword({ dispatch }, data) {
    const { currentPassword, newPassword, notification } = data;
    try {
      const changePassword = await SecurityService.changePassword(currentPassword, newPassword);
      dispatch('addNotification', notification);
      return changePassword;
    } catch (err) {
      const errorNotification = {
        type: 'error',
        message: `feedback.errors.${notification.fieldToEdit}`,
        show: notification.show
      };
      dispatch('addNotification', errorNotification);
      console.error(err);
    }
  }
};

export const mutations = {
  SET_PROFILE(state, profile) {
    state.profileData = profile;
    loadLanguageAsync(profile.lang || 'en');
  },
  SET_PERMISSIONS(state, data) {
    state.permissions = data;
  },
  SET_PROFILE_FORMS(state, data) {
    state.profileForms = [
      {
        label: 'nouns.firstName',
        value: data.name,
        fieldToEdit: 'firstName'
      },
      {
        label: 'nouns.surname',
        value: data.surname,
        fieldToEdit: 'surname'
      },
      {
        label: 'nouns.email',
        value: data.email,
        fieldToEdit: 'email',
        action: 'components.dataAccount.edit.editEmail'
      },
      {
        label: 'nouns.password',
        value: '************',
        type: 'password',
        fieldToEdit: 'password'
      },
      {
        label: 'nouns.language',
        value: data.lang,
        fieldToEdit: 'lang'
      }
    ];
  }
};
